<template>
  <div class='copyright-content'>
    <p>
      <span>版权所有© 杭州马兰头医学科技有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022002007号</a>
    </p>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="less" scoped>
.copyright-content {
  background: #374367;
  color: #fff;
  padding: 24px 0;
  text-align: center;
  line-height: 17px;
  border-top: 1px solid #979797;
  >p {
  //   >span:not(:first-child) {
  //     margin-left: 10px;
  //   }
  //   &:first-child {
  //     margin-bottom: 17px;
  //   }
  //   &:last-child {
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     .img {
  //       margin-left: 10px;
  //       width: 20px;
  //     }
  //   }
    a {
      color: #fff;
      margin-left: 20px;
    }
  }
}
</style>